import Constants from '@/Constants';
import { Person } from '@/models/Person';
import { Profile } from '@/models/Profile';
import { User } from '@/models/User';

let castAuthorization: string;

const getAuth = (): string | null => castAuthorization || localStorage.getItem('castAuthorization');

const setAuth = (authorization: string) => {
    castAuthorization = authorization;
    localStorage.setItem('castAuthorization', authorization);
};

const clearAuth = (): void => {
    castAuthorization = '';
    localStorage.clear();
};

let castLocale: string;

export const setLocale = (locale: string) => {
    castLocale = locale;
    localStorage.setItem('castLocale', locale);
};

const getLocale = (): string | null => castLocale || localStorage.getItem('castLocale') || 'pt';

export const onboardRequired = (user: User, person: Person): boolean => {
    const studentProfile = user.profiles.find((p: Profile) => p.profileKey === 'STUDENT');
    return !!studentProfile && !person.onboarded && person.locale === Constants.language.PT;
};

export { getAuth, setAuth, clearAuth, getLocale };
